import React from 'react';
export function ClosingPhrase() {
  return <section className="w-full bg-warm-500 py-24 md:py-32 px-6" data-id="element-40">
      <div className="max-w-4xl mx-auto text-center" data-id="element-41">
        <p className="font-serif text-3xl md:text-5xl text-white leading-relaxed md:leading-loose" data-id="element-42">
          La maternidad no se trata de hacerlo perfecto.
          <br data-id="element-43" />
          <span className="italic opacity-90" data-id="element-44">
            Se trata de aprender… de confiar… de acompañarte en el proceso
          </span>
        </p>
      </div>
    </section>;
}